import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './OrderHistoryDetails.scss';
import { Helmet } from "react-helmet";
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiCalendar, mdiClockTimeTwoOutline, mdiClipboardTextSearchOutline, mdiPatioHeater } from '@mdi/js';
import { Link, useLocation, useNavigate, NavLink } from 'react-router-dom';
import CustomFunction from '../../components/customFuction';
import axios from "axios";
import { APP_LOAD, HANDLE_401_ERROR, USER_LOAD } from '../../constants/actionTypes';
import agent from '../../agent';
import Modal from 'react-modal';
import { useForm, Controller, set } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import closeIcon from "../../Views/TuneUp/CloseIcon.svg";
import dollarIcon from "../TuneUp/CurrencyBg.svg";
import calendarIcon from "./images/OrderCalendar.svg";
import clockIcon from "./images/OrderClock.svg";
import durationIcon from "./images/OrderDuration.svg";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import HorizontalScrollView from './HorizontalScrollView';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import pendingIcon from "./images/Pending.svg";
import completeIcon from "./images/Complete.svg"
import Footer from '../../components/Footer/Footer';


const mapStateToProps = state => ({ ...state });

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, setData) => {
    // setData(payload) // update the data state in the parent component
    dispatch({ type: USER_LOAD, payload, skipTracking: true });
  }
});


const OrderHistoryDetails = (props) => {
  //console.log("props of order history details", props);
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true)
  const [isLoadingData, setLoadingData] = useState(true);
  const [singleOrderDetails, setSingleOrderDetails] = useState('');
  const [cancelOrderDetails, setCancelOrderDetails] = useState('');
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [cancelOrderID, setCancelOrderID] = useState('');


  const [orderDetailsError, setOrderDetailsError] = useState('');
  const [orderDetailsSuccess, setOrderDetailsSuccess] = useState('');
  const [profileInfo, setProfileInfo] = useState("");
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [paymentChargeSuccess, setPaymentChargeSuccess] = useState([]);
  const [paymentModalIsOpen, setPaymentModalISOpen] = useState(false);
  const [paymentUpdateModel, setPaymentUpdateModel] = useState(false);
  const [paymentChargeError, setPaymentChargeError] = useState('');
  const [paymentTipData, setPaymentTipData] = useState('');
  const [paymentChargeId, setPaymentChargeId] = useState([]);
  const [paymentCompleteSuccess, setPaymentCompleteSuccess] = useState('');
  const [paymentCompleteError, setPaymentCompleteError] = useState('');
  const [paymentInfoError, setPaymentInfoError] = useState("");
  const [iscancelorder, setIsopens] = React.useState(false);

  const [selectedImage, setSelectedImage] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [timeHours, setTimeHours] = useState(null);


  let pathname = location.pathname;
  pathname = pathname.trim().split("/");
  //console.log("pathname", pathname[2])


  const fetchData = async () => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const response = await axios.get(
        process.env.REACT_APP_RIDEDOC_API_ROOT + `order/${pathname[2]}`, config
      );
      // console.log(response, "response");
      setLoading(false);
      setSingleOrderDetails(response?.data?.results);
    } catch (error) {
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
    }


  };

  // console.log("order details", singleOrderDetails);


  useEffect(() => {

    fetchData();
    getProfileInfo();
    // props.onLoad(agent.Auth.current());

    // setTimeout(() => {
    //   setLoading(false)
    // }, 1000);
  }, []);

  useEffect(() => {
    if (profileInfo) {
      getPaymentChargeInfo();
    }
  }, [profileInfo]);


  useEffect(() => {
    if (paymentChargeSuccess && paymentChargeSuccess.length > 0) {
      setPaymentModalISOpen(true);
    } else {
      setPaymentModalISOpen(false);
    }
  }, [paymentChargeSuccess]);

  useEffect(() => {
    if (paymentCompleteSuccess) {
      fetchData();
    }
  }, [paymentCompleteSuccess])

  const getPaymentChargeInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/pending-charges/user/${profileInfo}`, config);
     // console.log("Pending charge data", data);
      setPaymentChargeSuccess(data?.results);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
    }
  };

  const handleFormSubmit = async (data, charge, index) => {
    //console.log("data on submit", data);
    // console.log("selected payment charge", paymentChargeSuccess[index])

    let tip = paymentTipData;
    if (!tip) {
      tip = 0;
    }
    setButtonLoading(true)
    setPaymentInfoError('');
    setTimeout(() => {
      setPaymentUpdateModel(true);
    }, 2000)
    paymentComplete(charge, data, index, tip);
  }

  const paymentComplete = async (data, charge, index, tip) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    setPaymentChargeId(paymentChargeSuccess[index].order)
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const val = {
        tip_cost: tip
      };
      // const userID = props?.common?.currentUser?.results?._id;
      //console.log("tip-payment", paymentTipData);

      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${paymentChargeSuccess[index]._id}/complete`, val, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      setPaymentCompleteSuccess(response);
      setButtonLoading(false);
      // setPaymentModalISOpen(false);     
      setPaymentModalISOpen(false);
      setPaymentUpdateModel(true);
     

      // navigate('/order-details/' + paymentChargeSuccess[index].order);
    } catch (error) {
      setPaymentInfoError(error.response.data.message)
      setButtonLoading(false);
      setPaymentModalISOpen(false);
      setPaymentCompleteError(true);
      HANDLE_401_ERROR(error.response?.status);
     // console.log("payment charge complete error", error);
    }
  }


  const paymentComplete1 = async (charge, index) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const val = {
        tip_cost: '0'
      };
      // const userID = props?.common?.currentUser?.results?._id;
      //console.log("tip-payment on close", paymentTipData);
      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${charge?._id}/complete`, val, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      setPaymentCompleteSuccess(response);
      setButtonLoading(false);
      // if(paymentCompleteSuccess){
        // setPaymentCompleteSuccess(true);
        // setPaymentModalISOpen(false);
      // }
      // navigate('/order-details/' + paymentChargeSuccess[index].order);
    } catch (error) {
      setPaymentInfoError(error);
      setPaymentCompleteSuccess(error);
      setButtonLoading(false);
      HANDLE_401_ERROR(error.response?.status);
     // console.log("payment charge complete error", error);
    }
  }

  const handleInput = (e) => {
    setPaymentTipData(e.target.value);
      }

  function bookingModalIsCloseModal() {
    // setBookingModalISOpen(false);
    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);

    // navigate('/order-details/' + paymentChargeId);
  }

  const handleButtonClick = () => {

    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);
  }


  // let orderdetails = singleOrderDetails;
 // console.log("order details", singleOrderDetails);
  let orderDate = '';
  let orderTime = '';
  let mecName = '';
  let orderStatusColor = '#ffb400';


  if (singleOrderDetails) {

    //console.log("order details", singleOrderDetails)

    // orderDate = new Date(singleOrderDetails.slot_date).toString().substring(4, 15);
    // orderTime = CustomFunction.toHoursAndMinutes(singleOrderDetails.slot_time);

    const slotTime = singleOrderDetails?.slot_time;
   // console.log("slot-time", slotTime);// Assuming slotTime is in minutes
    const hours = Math.floor(slotTime / 60);
    const minutes = slotTime % 60;

    let period = "AM";
    if (hours >= 12) {
      period = "PM";
    }
    let adjustedHours = hours % 12;
    if (adjustedHours === 0) {
      adjustedHours = 12;
    }

    function formatTime(hours, minutes, period) {
      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");
      return `${formattedHours}:${formattedMinutes} ${period}`;
    }


    orderTime = formatTime(adjustedHours, minutes, period);
    //console.log("order-time", orderTime);

  
    
  
    const currentTime = new Date();
    const orderDateTime = new Date(singleOrderDetails?.slot_date_time);
    
    const calculateTimeHours = () => {
      const timeDifference = Math.abs(orderDateTime - currentTime);
      const calculatedTimeHours = timeDifference / 3.6e6;
    
      if (calculatedTimeHours < 2) {
        setTimeHours('You are Canceling Within 2 Hours Of Your Appointment Time. Cancelation Fee May Apply. Are You Sure?');
      } else {
        setTimeHours('Are you sure you want to cancel?');
      }
    };
    
    if (timeHours === null) {
      calculateTimeHours();
    }
    
  

    
    
    // Call the function to calculate and set the timeHours value
    // calculateTimeHours();





    // console.log("orderDate", orderDate);
    // console.log("Order Time ", orderTime);
    orderStatusColor = CustomFunction.orderStatusFnColor(singleOrderDetails.service.status)
    if (singleOrderDetails.mechanic) {
      mecName = singleOrderDetails.mechanic.firstName + ' ' + singleOrderDetails.mechanic.lastName;
    }
  }


  const validationSchema = Yup.object({
    order_payment_tip: Yup.string().nullable()
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm(formOptions);

  const customStyles1 = {
    content: {
      top: 40,
      left: 0,
      right: 0,
      bottom: 0,
      margin: '0 auto',
      background: 'rgba(255, 255, 255, 0.95)',
      maxWidth: '550px',
      padding: '30px 15px 0',
      width: '100%',
      maxHeight: '400px',
      borderRadius: '30px',
      border: '0.5px solid #000000'
    }
  };

  const customStyles = {
    content: {
      top: '54%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  }


  const customStyles2 = {
    content: {
      top: '160px',
      left: 0,
      right: 0,
      bottom: '160px',
      margin: '0 auto',
      background: 'rgba(255, 255, 255, 0.95)',
      maxWidth: '520px',
      padding: '30px 15px 0',
      width: '100%',
      maxHeight: '360px',
      borderRadius: '30px',
      border: '0.5px solid #000000'
    }
  };




  const paymentModalIsCloseModal = (charge, index) => {
    setPaymentModalISOpen(false);
    // paymentComplete1(charge, index);
  }

  const getProfileInfo = async () => {
    // setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken)
    // const refreshToken = JSON.parse(localStorage.getItem("refresh_token"));
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'user', config);
      setProfileInfo(data?.results?._id);


    }

    catch (error) {
     // console.log(error)
      HANDLE_401_ERROR(error.response?.status);
      // setLoading(false);
    }
  }

  function dateFormat(dateString) {
    const date = new Date(dateString);
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options).replace(/, /g, ', ');
    return formattedDate;
  }



  // function dateFormat(dateString) {
  //   const date = new Date(dateString);
  //   const options = { month: 'short', day: '2-digit', year: 'numeric' };
  //   const formattedDate = date.toLocaleDateString('en-US', options).replace(/, /g, '-').replace(/ /g, '-');
  //   return formattedDate;
  // }

  function dateFormat1(dateString) {
    const date = new Date(dateString);
    const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options).replace(/, /g, '-').replace(/ /g, '-');
    return formattedDate;
  }

  function formattedTime(dateString) {

    const date = new Date(dateString);
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const formattedTime = date.toLocaleTimeString('en-US', options);
    return formattedTime;
  }

  function totalCost(cost) {
    const formattedCost = cost.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return formattedCost;
  }
  const cancelOrderModal = (orders) => {
    setIsOpen(true);
    // console.log("orders", orders);
    setCancelOrderID(orders);
  }

  const cancelOrder = async (data) => {
   // console.log("cancelID data", data)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    setLoading(true)
    let val = {
      status: 'cancelled',
      _id: data?._id,
      message: 'Order has been canceled client side.'
    }
    try {

      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };

      const { data } = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `orders/mechanic/${pathname[2]}`,
        val,
        config
      );
      // console.log(data)
      await fetchData();
      setIsOpen(false);
      setLoading(false)
      setOrderDetailsSuccess(data.message)

    } catch (error) {
    //  console.log(error)
      setLoading(false)
      setOrderDetailsError(error.response.data.message);
      HANDLE_401_ERROR(error.response?.status);
    }
  };

  // const customStyles = {
  //   content: {
  //     top: '50%',
  //     left: '50%',
  //     right: 'auto',
  //     bottom: 'auto',
  //     marginRight: '-50%',
  //     transform: 'translate(-50%, -50%)',
  //     background: '#fff',
  //     maxWidth: '420px',
  //     padding: '0',
  //     width: '100%'
  //   },
  // };
  function closeModal() {
    setIsOpen(false);
  }


  const handleCancelOrder = async () => {

    //setLoading(true);

    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log(accessToken, "acess token");

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };

      // console.log("config", config);
      // console.log(cancelOrderID);
      const { data } = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + 'order/' + cancelOrderID + '/customer/cancel', {}, config
      );
     // console.log(data?.results, " cancel order response");
      //setLoading(false);
      setCancelOrderDetails(data?.results);
      setIsopens(true);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      setIsOpen(false);
      // setLoading(false);
      setOrderDetailsSuccess("Request succeeded");
      HANDLE_401_ERROR(error.response?.status);
      // setLoadingData(true);
      setOrderDetailsError(error?.message);
      fetchData().then(() => {
        setLoading(false);
      })
      // console.log(error)
    }
  }

 // console.log("sinle order", singleOrderDetails);
 // console.log("cancel ORders", singleOrderDetails?.payment_charge?.stripe_result?.payment_method_details?.card?.last4);

  const img_calendar = './images/calender_new.png';

  const orderHistoryBackground = require('../OrderHistoryDetails/images/Order History Details.png')


  const handleOrderImageClick = (index) => {
    // const imageUrl = singleOrderDetails?.vehicle_images[0];
    // if (imageUrl) {
    setSelectedImage(index);
    setLightboxOpen(true);
    // }
  };

  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <>
      <div className='order-details-bg'>
        <div className='main' >
          <Helmet>
            <title>RideDoc | Order Details </title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <Link to="/order-history" className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </Link>
              </div>
              <div className="header-text">
                <p>Order History Details</p>
              </div>
            </header>
          </div>
          <div className='main-wrapper'>
            {/* {orderDetailsError && <span className='error mt20'>{orderDetailsError}</span>} */}
            {orderDetailsSuccess && <span className='success mt20'>{orderDetailsSuccess}</span>}
            {singleOrderDetails ?
              <div className="odr-hsdd-wrp">
                {/* <div className='order-history-banner' style={{position: "relative"}}> */}
                <div className='order-banner-image'>
                  < img src={dollarIcon} alt='' />
                  <div className='order-service-cost'>
                    <p><span>{singleOrderDetails?.plan?.currency} {Math.ceil(singleOrderDetails?.customer_cost)}</span></p>
                  </div>
                </div>  
                <div className='order-service-name'>
                  <p style={{fontSize: "1.09rem", paddingTop: "2px", paddingBottom: "1px"}}>{singleOrderDetails?.plan?.display_name}</p>
                </div>
                {/* </div> */}
                
                <div className="odr-hsdd-status p-rel" style={{ 'background': CustomFunction.orderStatusFnColor(singleOrderDetails?.status), height: "6rem", marginTop: "-57px" }}>
                  <div className="odr-hsdd-cnt">
                    <div className='order-heading'>
                      <div className="order-id">
                        <span className="order-id-lbl order-style">Order No:</span>
                        <span className="order-id-name order-style">{singleOrderDetails?.ref_id}</span>
                      </div>
                      <div className='order-status'>
                        <div className='order-wrapper'>
                          <span className='order-id-lbl order-style'>{CustomFunction.orderStatusFn(singleOrderDetails.status)}</span>
                        </div>
                      </div>
                    </div>
                    <div className='order-box-bottom orders-data'>
                      <div className="order-calendar">
                        <img src={calendarIcon} alt='' className='img-calendar' />
                        <span className='order-date'>{dateFormat(singleOrderDetails?.slot_date_time)}</span>
                      </div>
                      <div className="order-time">
                        <img src={clockIcon} alt='' className='img-time' />
                        <span className='orderdata-time'>{orderTime}</span>
                      </div>
                      <div className="order-duration">
                        <img src={durationIcon} alt='' className='img-duration' />
                        <span className='orderdata-duration'>{singleOrderDetails?.plan_duration} Mins</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="odr-mec-details">
                  <div className="odr-mec-dd-in">
                    {/* <div className="odr-mec-ic"> */}
                      {(singleOrderDetails.status == 'open') &&
                        <img src= {pendingIcon} alt="" />
                      }
                      {(singleOrderDetails.status == 'cancelled') &&
                        <img src= {completeIcon} alt="" />
                      }
                      {(singleOrderDetails.status == 'completed') &&
                        <img src= {completeIcon} alt="" />
                      }
                      {(singleOrderDetails.status == 'confirmed') &&
                        <img src= {completeIcon} alt="" />
                      }
                      {(singleOrderDetails.status == 'ontheway') &&
                        <img src= {completeIcon} alt="" />
                      }
                    {/* </div> */}
                    <div className="odr-mec-cnt"  >
                      {(singleOrderDetails.status == 'open') &&
                        <div className='order-status-open'>
                          <span className="odr-mec-pend-sts order-mech">Mechanic </span>
                          <span className="odr-mec-pend-sts" style={{ fontWeight: 300 }}>To Be Assigned</span>
                        </div>
                      }
                      {(singleOrderDetails.status == 'cancelled') &&
                        <span className="odr-mec-pend-sts">Your order has been cancelled</span>
                      }
                      {(singleOrderDetails.status == 'completed') &&
                        <div>
                          {/* <span className="odr-mec-pend-sts">Your order has been completed by</span>
                      <span className="odr-mec-lbl">Technician</span> */}
                          <span className="odr-mec-pend-sts order-mech">Mechanic </span>
                          <span className="odr-mec-name">{singleOrderDetails?.mechanic?.first_name} {singleOrderDetails?.mechanic?.last_name}</span>
                        </div>
                      }

                      {(singleOrderDetails.status == 'confirmed') &&
                        <div>
                          {/* <span className="odr-mec-pend-sts">Your order has been confirmed by</span>
                      <span className="odr-mec-lbl">Technician</span> */}
                          <span className="odr-mec-pend-sts order-mech">Mechanic </span>
                          <span className="odr-mec-name">{singleOrderDetails?.mechanic?.first_name} {singleOrderDetails?.mechanic?.last_name}</span>
                        </div>
                      }
                      {(singleOrderDetails.status == 'ontheway') &&
                        <div>
                          {/* <span className="odr-mec-pend-sts">Your order has been confirmed by</span>
                      <span className="odr-mec-lbl">Technician</span> */}
                          <span className="odr-mec-pend-sts order-mech">Mechanic </span>
                          <span className="odr-mec-name">{singleOrderDetails?.mechanic?.first_name + singleOrderDetails?.mechanic?.last_name}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <div className="odr-payment-wrp" style={{padding: "0.6rem 1rem"}}>
                  <div className="odr-payment-dd odr-payment-address">
                    <p className='order-service-location'>Service Location:</p>
                    <address className='order-address'>
                      {singleOrderDetails.address.address},<br />
                      {singleOrderDetails.address.zipcode}, {singleOrderDetails.address.city}, {singleOrderDetails.address.state}<br />
                      {singleOrderDetails.address.country} 
                    </address>
                  </div>

                  <div className="odr-payment-dd odr-payment-address" style={{paddingBottom: "1.2rem"}}>
                    <p className='order-service-location'>Bike Type:<span className='order-address' style={{ marginLeft: '5px' }}>{singleOrderDetails?.vehicle_type?.display_name}</span></p>
                    <p className='order-service-location'>Bike Make:<span className='order-address' style={{ marginLeft: '5px' }}>{singleOrderDetails?.vehicle_make?.name}</span></p>
                    <p className='order-service-location'>Gear:<span className='order-address' style={{ marginLeft: '5px' }}>{singleOrderDetails?.vehicle_gear?.display_name}</span></p>

                  </div>

                  <div className="odr-payment-dd odr-payment-address">
                    {/* <h4>Parts </h4> */}
                    {/* <p><strong>Bike Type: </strong>{singleOrderDetails.vehicle_model.display_name}</p> */}
                    <p className='order-service-location'> Questions and Notes:</p>
                    <p className='order-address' style={{whiteSpace: "pre-line"}}> {singleOrderDetails?.parts_replacement}</p>
                    {/* <p><strong>Bike Make: </strong>{singleOrderDetails.vehicle_model.display_name}</p> */}

                  </div>


                  {/* <h4 className=
                    {singleOrderDetails?.status === 'completed' || singleOrderDetails?.status === 'ontheway' ? 'order-help-display-none' :
                      'order-help'}>Need help with the Order? Click <span>
                      <Link to={{pathname : "/contact-us" }}  state = { singleOrderDetails }>
                        here
                      </Link>
                    </span></h4> */}
                </div>
                { singleOrderDetails?.vehicle_images && singleOrderDetails?.vehicle_images.length > 0 && singleOrderDetails?.vehicle_images[0].length > 0 && singleOrderDetails?.vehicle_images[0] !== undefined && singleOrderDetails?.vehicle_images[0] !== null  ?
                  <>
                    <div className='order-image-top-text'>
                      <h4 style={{ fontSize: 12 }}>Pictures</h4>
                    </div>
                    <div className='order-image-upload'>
                      <div  className='length-txt'>
                        <h1 className='length-txt1' onClick={() => handleOrderImageClick(0)}> +{singleOrderDetails?.vehicle_images[0].length}</h1>
                      </div>
                      {/* {singleOrderDetails?.vehicle_images[0]?.map((item, index) => {
                        return(
                          <div key={index} src={item} onClick={() => handleOrderImageClick(index)}>
                            {index === 0 && (
                              <h1 className='length-txt'>+{singleOrderDetails?.vehicle_images[0].length}</h1>
                            )}
                          </div>
                        )
                      })}  */}
                      <HorizontalScrollView>
                        {singleOrderDetails?.vehicle_images[0]?.map((item, index) => {
                          return (<img key={index} src={item} alt='' className='order-image'
                            onClick={() => handleOrderImageClick(index)}
                          />)
                        })}

                        {/* <h4 className={
                          singleOrderDetails?.status === 'confirmed' || singleOrderDetails?.status === 'open' ? 'order-image-count' :
                            singleOrderDetails?.status === 'cancelled' ? 'order-image-count-cancel' : singleOrderDetails?.status === 'completed' || singleOrderDetails?.status === 'ontheway' ?
                              'order-image-count-completed' : 'order-image-count-custom'
                        }>+3</h4> */}
                      </HorizontalScrollView>
                    </div>
                  </>
                  :
                  null
                }

                {/* {(singleOrderDetails?.cancel_status == 'user_cancelled') ?
                  <div className="odr-mec-details"  >
                    <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: "3px" }}>
                      <p style={{ fontWeight: "bold" }}>Order Canceled BY:<span style={{ fontWeight: "300", marginLeft: '5px' }}>Customer</span></p>
                    
                    </div>
                  </div>
                  :
                  (singleOrderDetails?.cancel_status == 'mechanic_cancelled') ?
                    <div className="odr-mec-details"  >
                      <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: "3px" }}>
                        <p style={{ fontWeight: "bold" }}>Order Canceled BY:<span style={{ fontWeight: "300", marginLeft: '5px' }}>Mechanic</span></p>
                        {/* <p>{singleOrderDetails.cancel_status == 'user_cancelled' ? 'Customer' : 'Mechanic'}</p> */}
                {/* </div> */}
                {/* </div> */}
                {/* : */}
                {/* null */}
                {/* } */}

                {(singleOrderDetails.cancel_status != null && singleOrderDetails.cancel_status != 'user_updated' && (singleOrderDetails.status == 'open' || singleOrderDetails.status == 'cancelled')) &&
                  <div className="odr-mec-details"  >
                    <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: "0.3rem" }}>
                      <p style={{ fontWeight: "bold", color: "#000000", fontSize: "1rem" }}>Order Cancelled By:<span style={{ fontWeight: "300", marginLeft: '10px', color: "#000000", fontSize: "1rem" }}>{singleOrderDetails.cancel_status === 'user_cancelled' ? 'Customer' : (singleOrderDetails.cancel_status === 'mechanic_cancelled' ? 'Mechanic'  : singleOrderDetails.cancel_status)}</span></p>
                    </div>
                  </div>
                }
                <h4 className=
                  {singleOrderDetails?.status === 'completed' || singleOrderDetails?.status === 'ontheway' ? 'order-help-display-none' :
                    'order-help'} style={{ marginLeft: "20px" }}>Need help with the Order? Click <span>
                    <Link to={{ pathname: "/contact-us" }} style={{fontSize: "1rem"}} state={singleOrderDetails}>
                      here
                    </Link>
                  </span></h4>

                {((singleOrderDetails?.status === "open")) ?
                  <div className='odr-his-btns custom'>
                    <div className='odr-his-col'>
                      <button className='btn btn-primary btn-cancel-order' onClick={() => cancelOrderModal(singleOrderDetails?._id)}>Cancel Order</button>
                    </div>
                    <div className='odr-his-col'>
                      <Link className=' btn btn-edit-order' to={"/order-edit/" + singleOrderDetails?._id} >Edit Order</Link>
                    </div>
                  </div>
                  : (singleOrderDetails?.status === "confirmed") ?
                    <div className='odr-his-btns custom'>
                      <div className='odr-his-col'>
                        <button className='btn btn-primary btn-cancel-order' onClick={() => cancelOrderModal(singleOrderDetails?._id)}>Cancel Order</button>
                      </div>
                      <div className='odr-his-col'>
                        <Link className='btn btn-primary btn-edit-order' to={"/order-edit/" + singleOrderDetails?._id} >Edit Order</Link>
                      </div>
                    </div>
                    // : (singleOrderDetails?.status === "ontheway") ?
                    //   <div className='odr-his-btns custom'>
                    //     <div className='odr-his-col'>
                    //       <Link className='btn btn-primary' to={"/order-edit/" + singleOrderDetails?._id} >Edit Order</Link>
                    //     </div>
                    //     <div className='odr-his-col'>
                    //       <button className='btn btn-primary' onClick={() => cancelOrderModal(singleOrderDetails?._id)}>Cancel Order</button>
                    //     </div>
                    //   </div>
                    : ((singleOrderDetails?.status === "cancelled") || (singleOrderDetails?.status === "completed")) || (singleOrderDetails?.status === "ontheway") ?
                      <div className='odr-his-btns custom'>
                      </div>
                      : <div className='odr-his-btns custom'>
                      </div>
                }
                {singleOrderDetails.payment_charge != null && singleOrderDetails.payment_charge?.stripe_result != null && (
                  <>
                    <div className='odr-payment-wrp order-payment-details'>
                      <h4 style={{paddingBottom: 1, color: "#000000", fontSize: "1rem"}}>Payment Details</h4>
                      <div className='order-service-charge'>
                        <span>Service Cost</span>
                        <span>${singleOrderDetails?.payment_charge?.total_service_adjustment_cost.toFixed(2)}</span>
                      </div>
                      <div className='order-parts'>
                        <span>{singleOrderDetails?.payment_charge?.partdesc}</span>
                        <span>${totalCost(singleOrderDetails?.payment_charge?.parts_cost)}</span>
                      </div>
                      <div className='order-service-charge'>
                        <span>Discount</span>
                        <span>- ${singleOrderDetails?.promo_discount_amount.toFixed(2)}</span>
                      </div>
                      <div className='order-tips'>
                        <span>Tips</span>
                        <span>${totalCost(singleOrderDetails?.payment_charge?.tips_cost)}</span>
                      </div>
                      <div className='order-tips'>
                        <span>Applicable Tax{singleOrderDetails?.payment_charge?.state_tax_percentage}%</span>
                        <span>${totalCost(singleOrderDetails?.payment_charge?.state_tax_cost)}</span>
                      </div>
                    </div>
                    <div className='odr-payment-wrp order-total'>
                      <span>Total</span>
                      <span>${totalCost(singleOrderDetails?.payment_charge?.amount )}</span>
                    </div>
                    <div className='odr-payment-wrp order-payment-method'>
                      <h6>Payment Method</h6>
                      <p>{singleOrderDetails?.payment_charge?.stripe_result?.source?.brand} ****{singleOrderDetails?.payment_charge?.stripe_result?.source?.last4}</p>
                      <span>{dateFormat1(singleOrderDetails?.payment_charge?.updatedAt)} {formattedTime(singleOrderDetails?.payment_charge?.updatedAt)}</span>
                    </div>
                    <div className='order-complete-status-footer'>
                      <h4 className='order-help-custom'>Need help with the Order? Click <span>
                        <Link to={{ pathname: "/contact-us" }} state={singleOrderDetails} >
                          here
                        </Link>
                      </span></h4>
                    </div>  
                    
                  </>
                  )}
              </div>
              :
              <div className='nonverify'>
                <Icon path={mdiClipboardTextSearchOutline} size={'60px'} color="#ff5f07" />
                <p className='nonverify-cnt'>Oops!, There is no order history details available.</p>
              </div>
            }

          </div>
        </div >
        <Footer />
      </div>

      {lightboxOpen && (
        <Lightbox
          mainSrc={singleOrderDetails?.vehicle_images[0][selectedImage]}
          nextSrc={selectedImage < singleOrderDetails?.vehicle_images[0]?.length - 1 ? singleOrderDetails?.vehicle_images[0][selectedImage + 1] : null}
          prevSrc={selectedImage > 0 ? singleOrderDetails?.vehicle_images[0][selectedImage - 1] : null}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() => setSelectedImage(selectedImage - 1)}
          onMoveNextRequest={() => setSelectedImage(selectedImage + 1)}
          toolbarButtons={[]}
          prevButtonRenderer={({ onClick, disabled }) => (
            <button type="button" className="custom-button" onClick={onClick} disabled={disabled}>
              <AiOutlineArrowLeft />
            </button>
          )}
          nextButtonRenderer={({ onClick, disabled }) => (
            <button type="button" className="custom-button" onClick={onClick} disabled={disabled}>
              <AiOutlineArrowRight />
            </button>
          )}
          prevButtonProps={{
            disabled: selectedImage === 0
          }}
          nextButtonProps={{
            disabled: selectedImage === singleOrderDetails?.vehicle_images[0]?.length - 1
          }}
        />
      )}







      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> */}
        {/* <button >close</button> */}
       {}
        <div className='modal-hd order-cancel-popup'>
          <h5 className='cancel-title'>{timeHours}</h5>
          <div className='modal-prmt-btns' style={{marginTop: "15px"}}>
            <div>
              <button className='btn btn-primary cancel-btn' onClick={closeModal}>No</button>
            </div>
            <div>
              <button className='btn btn-primary cancel-btn' onClick={handleCancelOrder}>Yes</button>
            </div>
          </div>
        </div>

      </Modal>
      {paymentModalIsOpen && (
        <>
          {paymentChargeSuccess.map((charge, index) => {
            const handleCloseModal = () => paymentModalIsCloseModal(charge, index);
            return (
              <Modal
                key={index}
                isOpen={paymentModalIsOpen}
                onRequestClose={handleCloseModal}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                ariaHideApp={false}
                style={customStyles}
                // className="time-slot-popup"
                overlayClassName="modal-Overlay"
                contentLabel="bookingOrderTimeSlot"
              >
                <h3 style={{ textAlign: "center", fontSize: 20, paddingTop: 20 }}>Payment Confirmation</h3><br></br>
                <div className="rd-popup-hd rd-popup-hd-orderid">
                  Order No: {charge.ref_id}
                </div>
                <div className="rd-popup-hd rd-popup-hd-servicecost">
                  Service Cost : ${(charge?.total_service_adjustment_cost ?? 0).toFixed(2)}
                </div>

<div className="rd-popup-hd rd-popup-hd-partcost">
  Parts Cost : ${(charge?.parts_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-discount">
  Discount : -${(charge?.order?.promo_discount_amount ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-tax">
  Tax ({charge?.state_tax_percentage ?? 0}%) : ${(charge?.state_tax_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-totcost">
  Total Cost : ${(charge?.customer_total_billing_cost ?? 0).toFixed(2)}
</div>
                <div className='booking-wrp tips-popup'>
                  <div className='rd-popup-wrp'  style={{display: "initial"}}>
                    {/* {console.log("order-success", paymentChargeSuccess)} */}
                    <section className="profile-info-sec-wrp" style={{marginLeft: "2rem", marginRight: "2rem"}}>
                      <div className="rd-popup-close">
                        <button className='reg-close' onClick={handleCloseModal}>
                          <img src={closeIcon} alt='close Icon' />
                        </button>

                      </div>
                      {/* {paymentChargeError && <span className='error'>{paymentChargeError}</span>}
                    {paymentChargeSuccess && <span className='success'>{paymentChargeSuccess}</span>} */}
                      <form onSubmit={handleSubmit((data) => handleFormSubmit(data, charge, index))}>

                        <div className="form-group-wrp">

                          <div className="form-group-wrp">
                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                <label className="form-lbl form-lbl-profileinfo" htmlFor="order_payment_tip" style={{top: "-6px", color: "black", backgroundColor: "white"}}>Tips</label>
                              <input className="form-control form-height" type="text" defaultValue=""  {...register('order_payment_tip')} onInput={handleInput} name="order_payment_tip" id="order_payment_tip" />
                                  {/* <input hidden className="form-control" {...register('payment_charge_id')} defaultValue={charge._id} type="text" name="payment_charge_id" id="payment_charge_id" />
                                  <input readOnly className="form-control" style={{ marginBottom: 30 }} {...register('payment_charge_amount')} defaultValue={charge.customer_total_billing_cost} type="text" name="payment_charge_amount" id="payment_charge_amount" />
                                  <label className="form-lbl form-lbl-payment" style={{ fontSize: 10 }} htmlFor="payment_charge_amount">Order Amount Payable</label>
                                  <input className="form-control form-height" type="text" defaultValue=""  {...register('order_payment_tip')} onInput={handleInput} name="order_payment_tip" id="order_payment_tip" />
                                  <label className="form-lbl form-lbl-profileinfo tip-lbl" htmlFor="order_payment_tip">Order Service Tip</label> */}
                                </div>
                                {errors.order_payment_tip &&
                                  <div className="invalid-feedback">{errors?.order_payment_tip.message}</div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>

                        {isButtonLoading ?
                          <div className="btn btn-primary">Loading...</div>
                          :
                          <button className="btn btn-primary" type="submit">Submit</button>
                        }
                      </form>
                    </section>
                  </div>
                </div>
              </Modal>
            )
          })};
        </>

      )
      }

      {
        paymentUpdateModel && (
          <>
            <Modal
              isOpen={paymentUpdateModel}
              onRequestClose={bookingModalIsCloseModal}
              // shouldCloseOnOverlayClick={false}
              ariaHideApp={false}
              style={customStyles}
              overlayClassName="modal-Overlay"
              contentLabel="bookingOrderTimeSlot"
            >
              <div className='booking-wrp order-booking-time-popup'>
                <div className='rd-popup-wrp'>
                  <div className="rd-popup-hd">
                    {/* <div className="rd-popup-close">

                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <Icon path={mdiClose} size={'15px'} color="#222" />
                </button>
              </div> */}
                  </div>
                  {paymentCompleteSuccess ? (
          <div className="rd-popup-content payment-message">
            <p className="pb10" style={{fontSize: "1.3rem", paddingBottom: "25px"}}>Payment Updated Successfully.</p>
            <div className="ok-button" style={{ width: "4.5rem", margin: "0 auto" }}>
              <button
                className="btn btn-primary btn-update-ok"
                onClick={handleButtonClick}
              >
                Ok
              </button>
            </div>
          </div>
        ) : null}   
        {paymentCompleteError ? (
          <div className="rd-popup-content payment-message">
            <p className="pb10" style={{fontSize: "1.3rem", paddingBottom: "25px"}}>Payment Updated Failed.</p>
            <div className='ok-button' style={{ width: "4.5rem", margin: "0 auto" }}>
              <button
                className="btn btn-primary btn-update-ok"
                onClick={handleButtonClick}
              >
                Ok
              </button>
            </div>
          </div>
        ) : null}
                </div>
              </div>
            </Modal>
          </>
        )
      }

      {
        iscancelorder && (
          <>
            <Modal
              isOpen={iscancelorder}
              onRequestClose={() => setIsopens(false)}
              shouldCloseOnOverlayClick={false}
              ariaHideApp={false}
              style={customStyles}
              overlayClassName="modal-Overlay"
              contentLabel="bookingOrderTimeSlot"
            >
              <div className='booking-wrp order-booking-time-popup'>
                <div className='rd-popup-wrp'>
                  <div className="rd-popup-hd">
                    {/* <div className="rd-popup-close">

                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <Icon path={mdiClose} size={'15px'} color="#222" />
                </button>
      </div> */}
                  </div>
                  <div className="rd-popup payment-message">
                    <p className='pb20' style={{ fontSize: "1.2rem" }}>Order No: <span style={{ fontWeight: 'bold' }}> {singleOrderDetails?.ref_id}</span></p>
                    <p className='pb20' style={{ fontSize: "1.2rem" }}> Order cancelled Successfully.</p>
                    <div className='ok-button' style={{ width: "4.5rem", margin: "0 auto" }}>
                      <button className="btn btn-primary btn-update-ok"
                        // onClick={() => {
                        //   navigate('/order-details/' + paymentChargeId)
                        // }}
                        onClick={() => setIsopens(false)}
                      >Ok</button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </>
        )
      }


    </>

  );

}
export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryDetails);